export default {
    dependencies: [
        '$element',
        'phonefetchingservice',
        'trackingservice',
        'templateservice',
        'sitesettings',
    ],
    callable(
        root,
        phonefetchingservice,
        trackingService,
        templateservice,
        sitesettings
    ) {
        let numberElems;
        let element;
        let state;
        init();

        function init() {
            element = root.querySelector('[data-showphonenumber-result]');
            numberElems = Array.from(
                root.querySelectorAll('[data-hidden-number]')
            );
            numberElems.forEach(e => {
                e.addEventListener('click', onRevealClick);
            });
            element.addEventListener('click', actionDelegate);
        }

        function getAttr(path, obj) {
            const parts = path.split('.');
            return parts.reduce((subject, pathPart) => {
                if (subject != null) {
                    return subject[pathPart];
                }

                return undefined;
            }, obj);
        }

        function showFeedback(error) {
            const context = {};
            context[state] = true;
            context.nextPeriodStart = getAttr(
                'response.result.result.nextPeriodStart',
                error
            );
            context.userPhone = sitesettings.userphone;
            element.classList.remove('hidden', 'u-display-none');
            element.innerHTML = renderUiBox(context);
            trackingService.trackEvent(
                `contact.show-phone.${formatTrackingName(state)}`,
                null,
                'effect'
            );
        }

        function formatTrackingName(name) {
            return name && name.replace(/([A-Z]{1})/g, '-$1').toLowerCase();
        }

        function hideFeedback() {
            element.classList.add('hidden', 'u-display-none');
        }

        function getCurrentAdId() {
            const u = new URL(document.baseURI);
            return u.searchParams.get('finnkode');
        }

        function onRevealClick(e) {
            e.preventDefault();
            phonefetchingservice
                .getNumber(getCurrentAdId())
                .then(getNumberSuccess, genericFailure);
            trackingService.deprecatedTrackEvent('user_showphone'); // "start old"
        }

        function getNumberSuccess(e) {
            hideFeedback();
            const numbers = e.phoneNumbers;
            numberElems.forEach(e => {
                e.removeEventListener('click', onRevealClick);
                const numberType = e.getAttribute('data-phone-type');
                const contactName = e.getAttribute('data-contact-name');
                const contact = numbers[contactName];
                if (contact) {
                    const number = contact[numberType];
                    if (number) {
                        const protocol = e.getAttribute('data-sms')
                            ? 'sms:'
                            : 'tel:';
                        e.href = protocol + number.replace(/\s/g, '');
                        if (protocol === 'tel:') {
                            e.textContent = number;
                        }
                        e.classList.remove('hidden', 'u-display-none');
                    }
                }
            });
            trackingService.deprecatedTrackEvent('user_showphone_ok'); // "success old"
            trackingService.trackEvent(
                'contact.show-phone.show',
                'success',
                'effect'
            );
        }

        function genericFailure(error) {
            const states = {
                NEED_VERIFICATION: 'needVerification',
                NEED_LOGIN: 'needLogin',
                INVALID_NUMBER: 'invalidNumber',
                WRONG_PIN: 'invalidPin',
                PIN_EXPIRED: 'pinExpired',
                BLOCKED: 'userBlocked',
            };

            state = states[error.status] || 'unknownState';
            showFeedback(error);
        }

        function renderUiBox(context) {
            return templateservice.render('ad.getphonenumber', context);
        }

        function actionDelegate(evt) {
            const action = evt.target.getAttribute('data-action');
            if (action) {
                evt.preventDefault();
            }

            switch (action) {
                case 'submit-phone':
                    submitPhone();
                    break;
                case 'submit-pin':
                    submitPin();
                    break;
            }
        }

        function submitPhone() {
            const number = element.querySelector('input').value;
            phonefetchingservice
                .requestPin(number)
                .then(submitPhoneSuccess, genericFailure);
        }

        function submitPhoneSuccess() {
            state = 'needPin';
            showFeedback();
        }

        function submitPin() {
            const pin = element.querySelector('input').value;
            phonefetchingservice
                .validatePin(pin)
                .then(submitPinSuccess, genericFailure);
        }

        function submitPinSuccess() {
            hideFeedback();
            onRevealClick();
        }
    },
};



// WEBPACK FOOTER //
// ./controllers/showPhoneNumber.js